<template>
  <div class="Slider">
    <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
      <!-- slides -->
      <swiper-slide v-for="(item, index) in sliderArr" :key='index'><img :src="item"/></swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination"  slot="pagination" v-if="sliderArr&&sliderArr.length>1"></div>
    </swiper>
    <div class="shadow"></div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'Slider',
  props: {
    sliderArr: {
      type: Array,
      default () {
        return []
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      swiperOption: {
        autoplay: this.sliderArr.length>1,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {el: '.swiper-pagination'}
      }
    }
  },
  methods: {
    callback () {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .Slider{
    width: 100%;
    margin: 0px auto;
  }
  img{
    width: 100%;
    height:580px;
  }
  /deep/ .swiper-pagination-bullet-active{
    background-color: #A7120C;
  }
  /deep/ .swiper-container-horizontal > .swiper-pagination-bullets{
    left: -20px;
  }
  .swiper-pagination{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/Slider.vue